import {useEffect, useState} from 'react';
import {useDispatcher} from '@netx/core-components/hooks/useDispatcher';
import {type ISavedCart} from '../schema';
import {useSavedCarts} from './useSavedCarts';

export type UseSavedCartArguments = {
	id?: number;
};

export const useSavedCart = ({id}: UseSavedCartArguments) => {
	const [savedCart, setSavedCart] = useState<ISavedCart>();
	const [loading, setLoading] = useState(false);

	const {savedCarts} = useSavedCarts();

	useEffect(() => {
		setSavedCart(
			id ? savedCarts.find((savedCart) => savedCart.id === id) : undefined,
		);
	}, [id, savedCarts]);

	// TODO: if we are handling the backbone collection right, this should not be needed...?
	useDispatcher('cart:rename:success', (savedCartModel) => {
		if (!id || savedCartModel.id !== id) return;
		setSavedCart((cart) =>
			cart
				? {
						...cart,
						title: savedCartModel.get('title'),
				  }
				: undefined,
		);
	});

	return {
		savedCart,
		loading,
	};
};

export default useSavedCart;
